import { Component } from '@angular/core';

@Component({
  templateUrl: './delete-account.page.html',
})
/**
 * Delete account page
 */
export class DeleteAccountPage {}
